export const incomeReportData = [
  {
    key: "1",
    INVOICENO: "#INV12345",
    IMAGE: "car-01.jpg",
    CAR: "Ford Endeavour",
    RENTALFEES: "$3,800",
    LATEFEES: "$200",
    ADDITIONALSERVICES: "$200",
    TOTALINCOME: "$5,100",
    DATE: "24 Jan 2025",
    STATUS: "Paid",
  },
  {
    key: "2",
    INVOICENO: "#INV12346",
    IMAGE: "car-02.jpg",
    CAR: "Ferrari 458 MM",
    RENTALFEES: "$3,500",
    LATEFEES: "$250",
    ADDITIONALSERVICES: "$150",
    TOTALINCOME: "$4,500",
    DATE: "19 Dec 2024",
    STATUS: "Pending",
  },
  {
    key: "3",
    INVOICENO: "#INV12347",
    IMAGE: "car-03.jpg",
    CAR: "Ford Mustang",
    RENTALFEES: "$4,600",
    LATEFEES: "$300",
    ADDITIONALSERVICES: "$200",
    TOTALINCOME: "$3,800",
    DATE: "11 Dec 2024",
    STATUS: "Paid",
  },
  {
    key: "4",
    INVOICENO: "#INV12348",
    IMAGE: "car-04.jpg",
    CAR: "Toyota Tacoma 4",
    RENTALFEES: "$4,100",
    LATEFEES: "$200",
    ADDITIONALSERVICES: "$200",
    TOTALINCOME: "$4,700",
    DATE: "29 Nov 2024",
    STATUS: "Overdue",
  },
  {
    key: "5",
    INVOICENO: "#INV12349",
    IMAGE: "car-05.jpg",
    CAR: "Chevrolet Truck",
    RENTALFEES: "$3,400",
    LATEFEES: "$250",
    ADDITIONALSERVICES: "$150",
    TOTALINCOME: "$5,300",
    DATE: "03 Nov 2024",
    STATUS: "Paid",
  },
  {
    key: "6",
    INVOICENO: "#INV12350",
    IMAGE: "car-06.jpg",
    CAR: "Etios Carmen",
    RENTALFEES: "$4,300",
    LATEFEES: "$200",
    ADDITIONALSERVICES: "$200",
    TOTALINCOME: "$4,000",
    DATE: "31 Oct 2024",
    STATUS: "Pending",
  },
  {
    key: "7",
    INVOICENO: "#INV12351",
    IMAGE: "car-07.jpg",
    CAR: "Acura Sport",
    RENTALFEES: "$4,900",
    LATEFEES: "$250",
    ADDITIONALSERVICES: "$150",
    TOTALINCOME: "$3,600",
    DATE: "15 Oct 2024",
    STATUS: "Paid",
  },
  {
    key: "8",
    INVOICENO: "#INV12352",
    IMAGE: "car-08.jpg",
    CAR: "Kia Soul 2016",
    RENTALFEES: "$3,600",
    LATEFEES: "$250",
    ADDITIONALSERVICES: "$150",
    TOTALINCOME: "$5,800",
    DATE: "26 Sep 2024",
    STATUS: "Failed",
  },
  {
    key: "9",
    INVOICENO: "#INV12353",
    IMAGE: "car-09.jpg",
    CAR: "Camaro",
    RENTALFEES: "$3,300",
    LATEFEES: "$200",
    ADDITIONALSERVICES: "$100",
    TOTALINCOME: "$4,200",
    DATE: "01 Sep 2024",
    STATUS: "Paid",
  },
  {
    key: "10",
    INVOICENO: "#INV12354",
    IMAGE: "car-10.jpg",
    CAR: "Toyota Camry",
    RENTALFEES: "$5,300",
    LATEFEES: "$300",
    ADDITIONALSERVICES: "$200",
    TOTALINCOME: "$3,900",
    DATE: "15 Aug 2024",
    STATUS: "Paid",
  },
];
